/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OWUserSessionEventType } from './OWUserSessionEventType';
import {
    OWUserSessionEventTypeFromJSON,
    OWUserSessionEventTypeFromJSONTyped,
    OWUserSessionEventTypeToJSON,
    OWUserSessionEventTypeToJSONTyped,
} from './OWUserSessionEventType';

/**
 * 
 * @export
 * @interface CreateOWUserEventBody
 */
export interface CreateOWUserEventBody {
    /**
     * 
     * @type {OWUserSessionEventType}
     * @memberof CreateOWUserEventBody
     */
    eventType: OWUserSessionEventType;
    /**
     * 
     * @type {string}
     * @memberof CreateOWUserEventBody
     */
    referralCampaign?: string;
}



/**
 * Check if a given object implements the CreateOWUserEventBody interface.
 */
export function instanceOfCreateOWUserEventBody(value: object): value is CreateOWUserEventBody {
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    return true;
}

export function CreateOWUserEventBodyFromJSON(json: any): CreateOWUserEventBody {
    return CreateOWUserEventBodyFromJSONTyped(json, false);
}

export function CreateOWUserEventBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOWUserEventBody {
    if (json == null) {
        return json;
    }
    return {
        
        'eventType': OWUserSessionEventTypeFromJSON(json['eventType']),
        'referralCampaign': json['referralCampaign'] == null ? undefined : json['referralCampaign'],
    };
}

export function CreateOWUserEventBodyToJSON(json: any): CreateOWUserEventBody {
    return CreateOWUserEventBodyToJSONTyped(json, false);
}

export function CreateOWUserEventBodyToJSONTyped(value?: CreateOWUserEventBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventType': OWUserSessionEventTypeToJSON(value['eventType']),
        'referralCampaign': value['referralCampaign'],
    };
}

